import React from "react";
import ProjectList from "./ProjectList";

const InProgressProjects = () => {
    return <ProjectList status="inprogress" title="All Projects"  />;
};

export default InProgressProjects;
